import React from 'react';
import { Experience as ExperienceType } from '../types';

const Experience: React.FC = () => {
  const experiences: ExperienceType[] = [
    {
      date: "2024 - Present",
      title: "Social Media Manager",
      company: "Freelance, Vienna",
      description: "Management of social media channels like Instagram and TikTok, content creation using Canva, CapCut, and DaVinci Resolve, and performance analysis through Meta Business Suite."
    },
    {
      date: "Jul 2023 - Sep 2023",
      title: "Customer Protection Analyst",
      company: "Entain, Vienna",
      description: "Identified and evaluated unusual user activity, maintained direct contact with users, monitored communications, and used CRM systems for case documentation."
    },
    {
      date: "Jul 2022 - Jun 2023",
      title: "Content Moderator",
      company: "Teleperformance, Lisbon",
      description: "Monitored user-generated content for the Pinterest project, reviewed flagged posts for compliance, mitigated system abuse, and supported community safety."
    },
    {
      date: "Oct 2021 - Jul 2022",
      title: "Sales Agent",
      company: "Teleperformance, Lisbon",
      description: "Promoted mobile services for the Salt project, consistently exceeding performance targets through practical, outcome-focused solutions and effective user communication."
    }
  ];

  return (
    <section id="experience" className="py-24 bg-bg-light">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-semibold text-center mb-16">
          Professional Experience
        </h2>
        
        {/* Timeline Container */}
        <div className="timeline-container">
          {/* Vertical Line */}
          <div className="timeline-line"></div>

          {/* Timeline Items */}
          {experiences.map((exp, index) => (
            <div key={index} className="timeline-item">
              <div className="timeline-content">
                <div className="timeline-title">{exp.title}</div>
                <div className="timeline-company">{exp.company}</div>
                <div className="timeline-description">
                  {exp.description}
                </div>
              </div>
              <div className="timeline-dot"></div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Experience; 